import React, { FC } from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import FontIcon from '../FontIcon';
import { Link } from '../Common';

const StyledButton = styled.button`
  display: flex;
  height: 56px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  background: var(--sys-color--surface-container-high);
  border-width: 0px;
  border-radius: 28px;
  width: 100%;
  padding: 0 18px;
  cursor: pointer;
`;

const SearchContainer = styled.div`
  margin: 16px;
`;

interface SearchButtonProps {
}

export const SearchButton: FC<SearchButtonProps> = () => {
  return (
    <Link
      to={`/v2/search`}
      pageDirection="FORWARD"
    >
      <SearchContainer>
        <StyledButton>
          <FontIcon name="search" size={24} color="var(--sys-color--on-surface-variant)" />
          <Typography variant="bodyLarge" color="var(--sys-color--on-surface-variant)">Search</Typography>
        </StyledButton>
      </SearchContainer>
    </Link>

  );
};
